import React from "react";

// A&A house-roof monogram inspired by the brand mark
export const Logo = ({ className = "h-10", showText = true, mono = false }) => {
  const gold = mono ? "currentColor" : "#D4AF37";
  const cream = mono ? "currentColor" : "#E7DCC0";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <svg viewBox="0 0 64 64" className="h-full w-auto" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        {/* roof */}
        <path d="M32 6 L58 30 L52 30 L32 12 L12 30 L6 30 Z" fill={gold} />
        {/* window */}
        <rect x="27" y="20" width="10" height="10" stroke={gold} strokeWidth="2" />
        <line x1="32" y1="20" x2="32" y2="30" stroke={gold} strokeWidth="1.5" />
        <line x1="27" y1="25" x2="37" y2="25" stroke={gold} strokeWidth="1.5" />
        {/* A & A */}
        <text x="32" y="54" textAnchor="middle" fontFamily="Montserrat, sans-serif" fontWeight="700" fontSize="20" fill={cream}>
          A&amp;A
        </text>
      </svg>
      {showText && (
        <div className="leading-none">
          <div className="font-heading font-semibold tracking-[0.18em] text-aa-cream text-sm sm:text-base">
            A&amp;A IMMOBILIERS
          </div>
          <div className="font-body text-[9px] sm:text-[10px] tracking-[0.25em] text-aa-gold mt-1 uppercase">
            Votre confiance, notre engagement
          </div>
        </div>
      )}
    </div>
  );
};
